import { render, staticRenderFns } from "./BicGroupForm.vue?vue&type=template&id=751b5c1e&"
import script from "./BicGroupForm.vue?vue&type=script&lang=js&"
export * from "./BicGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('751b5c1e')) {
      api.createRecord('751b5c1e', component.options)
    } else {
      api.reload('751b5c1e', component.options)
    }
    module.hot.accept("./BicGroupForm.vue?vue&type=template&id=751b5c1e&", function () {
      api.rerender('751b5c1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bic/BicGroupForm.vue"
export default component.exports